<template>
  <div class="player-wrap">
    <div class="mian">
      <div class="player-top-nav">
        <div class="back-link flex items-center" @click="goBack">
          <i class="iconfont icon-fanhui1"></i>
          <span>返回课程</span>
        </div>
        <div class="text-gray-500">
          <span>{{ title }}</span>
        </div>
      </div>

      <!-- 定义播放器dom -->
      <div class="playerrap">
        <div id="J_prismPlayer" class="prism-player" :key="playerKey" />
      </div>
    </div>
    <div style="position: relative">
      <i
        class="el-icon-s-unfold"
        @click="toggleCollapse"
        v-if="showSidebar"
      ></i>
      <i class="el-icon-s-fold" @click="toggleCollapse" v-else></i>
      <!-- 侧边栏 -->
      <div class="sidebar" v-if="showSidebar">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="目录" name="first"></el-tab-pane>
          <el-tab-pane label="问答" name="second"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName == 'first'" class="chapter-list">
          <el-collapse
            v-model="activeNames"
            @change="handleChange"
            v-if="chaptersList.length"
          >
            <el-collapse-item
              v-for="(item, index) in chaptersList"
              :key="item.id"
              :title="item.title"
              :name="index"
            >
              <div
                class="chapter-item flex justify-between items-center"
                :class="{ active: playVideoId == videoItem.id }"
                v-for="videoItem in item.videos"
                :key="videoItem.id"
                @click="handlPlayVideo(videoItem)"
              >
                <div class="flex items-center ml-left">
                  <i
                    class="iconfont icon-yiwancheng"
                    v-if="videoItem.is_watched == 1"
                  ></i>
                  <i
                    class="iconfont icon-a-weiwanchengweiwancheng"
                    v-if="videoItem.is_watched == 0"
                  ></i>
                  <span class="chapter-name">{{ videoItem.title }}</span>
                </div>
                <span class="sk" v-if="videoItem.free_seconds > 0" >试看</span>

                <!-- <span class="duration">{{ videoItem.duration }}</span> -->
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div v-if="activeName == 'second'">
          <div>

     
          <div class="question-editor">
            <quill-editor
              v-quill-placeholder="'请输入内容'"
              v-model="content"
              :options="editorOption"
            ></quill-editor>
          </div>

          <div class="controls flex items-center justify-between">
            <button
              class="btn btn-primary btn-sm pull-right"
              type="submit"
              @click="submit"
            >
              提问
            </button>
            <button
              class="btn btn-link btn-sm collapse-form-btn pull-right"
              type="button"
            >
              取消
            </button>
          </div>
           <!-- 此任务还有问题 -->
                </div>



        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Aliplayer from "aliyun-aliplayer";
// import "aliyun-aliplayer/dist/skins/default/aliplayer-min.css";
import "aliyun-aliplayer/build/skins/default/aliplayer-min.css";


import {
  getPlayAuth,
  getVideoPlayer,
  postWatchTime,
  postWenda,
  getWendaList
} from "@/service/course";


import formatTimePlugin from "@/util/vue-format-time.js";

export default {
  data() {
    return {
      title: "",
      playVideoId: "",
      playerKey: "",
      activeNames: ["0"],
      chaptersList: [],
      showSidebar: true,
      content: "",
      isShow: false,
      editorOption: {
        placeholder: "我要提问",
        modules: {
          toolbar: [
            ["bold", "italic"],
            ["link", "image"],
            [{ header: 1 }, { header: 2 }],
          ],
        },
      },
      activeName: "first",
      vid: "",
      playauth: "",
      currentTime: 0,
      player: null,
      currentVideo: {},
      courseInfo:{},
    };
  },

  /**
   * 页面渲染完成时：此时js脚本已加载，Aliplayer已定义，可以使用
   * 如果在created生命周期函数中使用，Aliplayer is not defined错误
   */
  created() {
    this.vid = this.$route.params.videoid;
    this.playerKey = this.$route.params.videoid;
    this.getVideoPlayerFn(this.$route.params.id);
    this.playVideoId = this.$route.params.id;
    if (this.$route.query.activeNames) {
      this.activeNames = JSON.parse(this.$route.query.activeNames);
    }
  },
  mounted() {
    this.getPlayAuthFn(this.$route.params.id);
  },
  methods: {
    async getPlayAuthFn(id) {
      let res = await getPlayAuth(id);
      this.playauth = res.data.PlayAuth;
    
      this.initPlayer();
    },

    initPlayer() {
         Aliplayer.__unable2Anti9Debugger13Key = 'error';
      if (this.playauth) {
        this.player = new Aliplayer(
          {
            id: "J_prismPlayer",
            vid: this.vid, // 视频id
            playauth: this.playauth, // 播放凭证
            encryptType: "1", // 如果播放加密视频，则需设置encryptType=1，非加密视频无需设置此项
            width: "100%",
            height: "calc(100vh - 66px)",
          }
          // function (player) {
          //   console.log("播放器创建成功");

          // }
        );
        this.player.on("pause", () => {
          const currentTime = this.player.getCurrentTime();
          this.saveProgressFn(this.playVideoId, { watch_seconds: currentTime });
        });

        this.player.on("ended", () => {
          const currentTime = this.player.getCurrentTime();
          // const totalTime = this.player.getDuration();
          // const progress = currentTime / totalTime;

          this.saveProgressFn(this.playVideoId, { watch_seconds: currentTime });
        });
        if (this.currentVideo.watched) {
          const targetTime = parseFloat(this.currentVideo.watched);
          // 确保播放器已经初始化完成后再调用 seek 方法
          this.player.on("ready", () => {
            this.player.seek(targetTime);
          });
        }
      }
    },
    // 看课进度
    async saveProgressFn(id, watchTimeData) {
      await postWatchTime(id, watchTimeData);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handlPlayVideo(e) {
      this.playerKey = e.videoid;
      this.playVideoId = e.id;
      this.vid = e.videoid;
      this.title = e.title;

      this.getPlayAuthFn(e.id);
    },
    handleChange(val) {
      console.log(val);
    },
    async getVideoPlayerFn(id) {
      let res = await getVideoPlayer(id);
      this.courseInfo = res.data.course;
      this.chaptersList = res.data.chapters;
      this.title = res.data.video.title;
      this.currentVideo = res.data.video;
    },
    goBack() {
      this.$router.go(-1);
    },
    toggleCollapse() {
      this.showSidebar = !this.showSidebar;
    },
    // 提问
    submit() {
      let data = {
        course_id: this.courseInfo.id, //课程id
        video_id: this.playVideoId, //视频id
        content: this.content, //提交问题
      };
      this.postWendaFn(data)
    },
    // 问答
    async postWendaFn(data) {
      let res = await postWenda(data);
      console.log(res);
      if(res.code == 0){
           this.$message.success("提交成功");
        // isshowEditor 
      let params ={
        id:data.course_id,
        video_id:data.video_id
      }
        this.getWendaListFn(params)
      }
    },
async getWendaListFn(params){
  let res= await getWendaList(params)
  console.log(res);
},
    // async getPlayAuthFn(id) {
    //   let res = await getPlayAuth(id);
    //   this.playauth = res.data.PlayAuth;
    // },
  },
};
</script>


<style lang="less" scoped>
.player-wrap {
  display: flex;
  height: 100vh;
  .mian {
    flex: 1 1 auto;
    padding: 0 34px 0px 12px;
    background-color: #f5f5f5;
  }
  .player-top-nav {
    display: flex;
    align-items: center;
    background-color: #f0f0f0;
    padding: 10px;

    height: 54px;
    line-height: 54px;
    color: #999;
    font-size: 16px;

    .back-link {
      cursor: pointer;
      .icon-fanhui1 {
        font-size: 28px;
      }
      span {
        color: #666;
        padding-right: 20px;
        border-right: 1px solid #c1c1c1;
        margin-right: 20px;
        margin-left: 6px;
      }
      span:hover {
        color: #0fce96;
      }
    }
    .back-link:hover {
      color: #0fce96;
    }
  }
}
.sidebar {
  width: 360px;
  flex: 0 0 360px;
  // background-color: #f5f5f5;
  padding: 10px;
  box-shadow: -5px 0 5px 0 rgba(0, 0, 0, 0.5);
  box-shadow: -2px 0 5px 0 rgba(0, 0, 0, 0.1);
  transition: width 0.3s ease;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chapter-item {
  padding: 15px;
  margin-top: 16px;
  cursor: pointer;
  .ml-left {
    flex: 1;
  }
  .ml-time {
    color: #9ca3af;
    margin-right: 5px;
  }
}
.chapter-item:hover {
  background: rgba(65, 105, 225, 0.1);
}
.chapter-item.active {
  background: rgba(65, 105, 225, 0.1);
  border-left: 3px solid #4169e1;
  border-radius: 8px;
}
.icon-bofang {
  color: #4169e1;
}
.icon-yiwancheng {
  color: #0fce96;
}
.question-editor {
  margin: 15px 0;
}
/deep/ .ql-editor {
  min-height: 200px;
  height: auto;
  background: #fff;
}
.el-icon-s-fold,
.el-icon-s-unfold {
  position: absolute;
  top: 50%;
  // right: 399px;
  left: -32px;
  margin-top: -24px;
  font-size: 22px;
  padding: 8px;
  padding-right: 3px;
  color: #fff;
  border-radius: 100px 0 0 100px;
  cursor: pointer;
  background: #46c37b;
}
.iconfont {
  margin-right: 8px;
}
/deep/.el-collapse {
  border-top: none;
  height: 100%;
  overflow-y: auto;
}
.duration {
  color: #888888;
}
.chapter-list {
  flex: 1;
  overflow: hidden;
}
</style>

